<template>
    <!--列表功能模板-->
    <el-row :gutter="4" class="h100 configurationList">
        <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                v-loading="showList && treeLoading">
            <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                 @click="showList = !showList"></div>
            <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                    <span slot="title">{{item.basicDataName}}</span>
                </el-menu-item>
            </el-menu>
        </el-col>
        <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
            <div class="el-table-container">
                <el-form size="small" class="query-form" ref="form" :model="form"
                         label-width="140px" @keyup.enter.native="refreshList(1)">
                    <div class="dynamicForm">
                        <el-form-item prop="keyword" label="输入搜索：">
                            <el-input v-model.trim="searchForm.keyword" maxlength="100"
                                      placeholder="关键字搜索"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item :label="item.basicRename + '：'" :prop="item.basicCode"
                                      v-for="(item, index) in basicDataInfo.whereList" :key="index"
                                      v-if="item.disabled == '0'">
                            <!--单选、多选、开关-->
                            <el-select class="w100i" v-model="form[item.basicCode]"
                                       :multiple="item.basicAssemblyId == 6 || item.basicAssemblyId == 7"
                                       placeholder="请选择" clearable
                                       v-if="item.basicAssemblyId == 4 || item.basicAssemblyId == 5 || item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 10">
                                <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                           :label="v.basicRange"
                                           :value="v.basicRange"></el-option>
                            </el-select>
                            <!--日期-->
                            <el-date-picker class="w100i"
                                            v-model="form[item.basicCode]" value-format="yyyy-MM-dd HH:mm:ss"
                                            :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                            :type="setDatePickerType(item, 1)"
                                            clearable start-placeholder="开始时间"
                                            end-placeholder="结束时间"
                                            v-else-if="item.basicAssemblyId == 9">
                            </el-date-picker>
                            <!--时间-->
                            <el-time-picker class="w100i" v-model="form[item.basicCode]"
                                            value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                            is-range range-separator="至" start-placeholder="开始时间"
                                            end-placeholder="结束时间"
                                            v-else-if="item.basicAssemblyId == 8"></el-time-picker>
                            <el-input v-model.trim="form[item.basicCode]" maxlength="100" placeholder="请输入" clearable
                                      v-else></el-input>
                        </el-form-item>
                    </div>
                    <div class="p_b04">
                        <el-button type="primary" icon="el-icon-search" @click="refreshList(1)" size="small">查询
                        </el-button>
                        <el-button type="primary" icon="el-icon-search" @click="refreshList(1, 2)" size="small">结果中查询
                        </el-button>
                        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                    </div>
                </el-form>
                <div class="p_all04 buttonBox">
                    <el-button :type="item.fonctionsNumber == 'page:delete' ? 'danger' : 'primary'" size="small"
                               :icon="item.detailIcon" v-for="(item, index) in basicDataInfo.pageFonctionsList"
                               :key="index" v-if="item.disabled == '0'" @click="operateBtn(item)">{{item.detailName}}
                    </el-button>
                </div>
                <div class="tips">
                    <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
                    已选择{{dataListSelections.length}}项数据
                </div>
                <el-table
                        :data="dataList"
                        size="small" height="100%"
                        class="table" ref="multipleTable" border
                        @selection-change="selectionChangeHandle" @sort-change="sortChange" row-key='id'
                        v-loading="loading">
                    <el-table-column type="selection" :reserve-selection='true' fixed/>
                    <el-table-column v-for="(item, index) in basicDataInfo.tableList" :key="index"
                                     :prop="item.basicCode"
                                     :label="item.basicRename"
                                     :sortable="item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12' ? 'custom' : false"
                                     show-overflow-tooltip v-if="item.disabled == '0'" min-width="100">
                        <template slot-scope="scope">
                            <span>{{listDataFormat(item, scope.row.jsonData[item.basicCode])}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="200">
                        <template slot-scope="{row}">
                            <div class="btnBox">
                                <el-button type="text" size="small"
                                           v-for="(item, index) in row.tableFonctionsList.length > 3 ? row.tableFonctionsList.slice(0,2) : row.tableFonctionsList"
                                           :key="index"
                                           @click="operateBtn(item, row)">{{item.detailName}}
                                </el-button>
                                <el-dropdown v-if="row.tableFonctionsList.length > 3">
                                    <el-link class="more" type="primary" :underline="false">更多<i
                                            class="el-icon-arrow-down el-icon--right"></i></el-link>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item, index) in row.tableFonctionsList.slice(2)"
                                                          :key="index" @click.native="operateBtn(item, row)" v-if="hideBtn(item, row)">
                                            {{item.detailName}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                            @pagination="refreshList"/>
            </div>
        </el-col>
        <ResourceAddEditForm ref="resourceAddEditForm" @refreshData="refreshList"></ResourceAddEditForm>
        <AdvancedSearch ref="advancedSearch" @getDataList="getSrhCondition"></AdvancedSearch>
        <ImportData ref="importData" @refreshData="refreshList"></ImportData>
        <ExportData ref="exportData"></ExportData>
        <DataMatching ref="dataMatching" @refreshData="refreshList"></DataMatching>
        <AuditForm ref="auditForm" @refreshData="refreshList"></AuditForm>
        <ListSetting ref="listSetting" @refreshData="getField(searchForm.basicDataId)"></ListSetting>
        <ChangeGrouping ref="changeGrouping" @refresh="refreshList"></ChangeGrouping>
        <RemoveGrouping ref="removeGrouping" @refresh="refreshList"></RemoveGrouping>
        <ChangeLabel ref="changeLabel" @refresh="refreshList"></ChangeLabel>
        <RemoveLabel ref="removeLabel" @refresh="refreshList"></RemoveLabel>
        <ChangeSubject ref="changeSubject" @refresh="refreshList"></ChangeSubject>
        <RemoveSubject ref="removeSubject" @refresh="refreshList"></RemoveSubject>
        <QualityInspection ref="qualityInspection" @refresh="refreshList"></QualityInspection>
        <SchemeList ref="schemeList" @refresh="refreshList"></SchemeList>
        <UrgentDeal ref="urgentDeal" @refresh="refreshList"></UrgentDeal>
        <Release ref="release" @refresh="refreshList"></Release>
        <Reorganize ref="reorganize" @refreshData="refreshList"></Reorganize>
        <SetDesensitizationRules ref="setDesensitizationRules" @refresh="refreshList"></SetDesensitizationRules>
        <AuditRecords ref="auditRecords"></AuditRecords>
        <ModifyPublish ref="modifyPublish" @refreshData="refreshList"></ModifyPublish>
        <BatchSorting ref="batchSorting" @refreshData="refreshList"></BatchSorting>
        <Storage ref="storage" @refreshData="refreshList"></Storage>
        <Removal ref="removal" @refreshData="refreshList"></Removal>
        <BackLibrary ref="backLibrary" @refreshData="refreshList"></BackLibrary>
        <Handover ref="handover" @refreshData="refreshList"></Handover>
        <Acceptance ref="acceptance" @refreshData="refreshList"></Acceptance>
    </el-row>
</template>

<script>
    import ImportData from '@/components/importData/importData'  // 导入弹窗
    import ExportData from '@/components/exportData/exportData'  // 导出弹窗
    import DataMatching from '@/components/dataMatching/dataMatching' // 数据匹配弹窗
    import AuditForm from '@/components/auditForm/auditForm' // 审核弹窗
    import AdvancedSearch from '@/components/advancedSearch/advancedSearch' // 高级筛选弹窗
    import ListSetting from '@/components/listSetting/listSetting' // 列表设置弹窗
    import ChangeGrouping from "@/components/resourcesGrouping/changeGrouping"; // 资源分组弹窗
    import RemoveGrouping from "@/components/resourcesGrouping/removeGrouping"; // 资源分组移除弹窗
    import ChangeLabel from "@/components/resourcesLabel/changeLabel"; // 资源标注弹窗
    import RemoveLabel from "@/components/resourcesLabel/removeLabel"; // 资源标注移除弹窗
    import ChangeSubject from "@/components/specialSubject/changeSubject"; // 资源专题弹窗
    import RemoveSubject from "@/components/specialSubject/removeSubject"; // 资源专题移除弹窗
    import Reorganize from "@/components/reorganize/reorganize"; // 资源整编弹窗
    import QualityInspection from "@/components/qualityInspection/qualityInspection"; // 质量检测
    import SchemeList from "@/components/testReport/schemeList"; // 检测报告
    import SetDesensitizationRules from "@/components/desensitization/setDesensitizationRules" // 脱敏后开放
    import UrgentDeal from "@/components/urgentDeal/urgentDeal" // 紧急处理
    import Release from "@/components/release/release";  // 发布
    import AuditRecords from "@/components/toExamine/auditRecords"; // 审核记录
    import ModifyPublish from "@/components/modifyPublish/modifyPublish";  // 已发布修改
    import BatchSorting from "@/components/batchSorting/batchSorting"; // 批量排序
    import Storage from "@/components/warehouse/storage"; // 接收入库
    import Removal from "@/components/warehouse/removal"; // 确认出库
    import BackLibrary from "@/components/warehouse/backLibrary"; // 确认回库
    import Handover from "@/components/warehouse/handover"; // 退库交接
    import Acceptance from "@/components/warehouse/acceptance"; // 移库验收
    export default {
        components: {
            BatchSorting,
            ModifyPublish,
            AuditRecords,
            Release,
            UrgentDeal,
            SetDesensitizationRules,
            SchemeList,
            QualityInspection,
            RemoveSubject,
            ChangeSubject,
            RemoveLabel,
            ChangeLabel,
            RemoveGrouping,
            ChangeGrouping,
            ListSetting,
            AuditForm,
            DataMatching,
            ImportData,
            ExportData,
            AdvancedSearch,
            Reorganize,
            Storage,
            Removal,
            BackLibrary,
            Handover,
            Acceptance,
        },
        data() {
            return {
                treeLoading: false,
                showList: true,
                basicDataList: [],
                form: {},
                searchForm: {
                    keyword: '',
                    basicDataId: '',
                    current: 1,
                    size: 20,
                    whereList: [],
                    sortArchivesDataElasticsearch: [],
                    metadataTableConfigId: this.$route.query.id,
                },
                basicDataInfo: {},
                loading: false,
                dataList: [],
                dataListSelections: [],
                total: 0,
                advancedList: [],  // 高级查询条件
                routeInfo: {}, // 当前路由信息
            }
        },
        mounted() {
            let dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
            this.routeInfo = dynamicMenuRoutes.filter(item => item.fullPath === this.$route.fullPath)[0]
            this.getField()
        },
        methods: {
            // 获取数据列表 current: 1第一页；searchType：2结果中查询，3高级查询
            refreshList(current, searchType) {
                this.$refs.multipleTable.clearSelection()
                if (current == 1) {
                    this.searchForm.current = 1
                }
                if (current == 1 && !searchType) {
                    this.searchForm.whereList = []
                }
                this.loading = true
                if (searchType != 3) {
                    let keys = Object.keys(this.form)
                    let values = Object.values(this.form)
                    keys.map((key, index) => {
                        let item = this.basicDataInfo.whereList.filter(v => v.basicCode == key)[0]
                        if ((item.basicAssemblyId == '6' || item.basicAssemblyId == '7') && Array.isArray(values[index]) && values[index].length) {
                            values[index].map(v => {
                                this.returnWhere(v, 'and', item.basicCode, '%', item.assemblyType)
                            })
                        } else if ((item.basicAssemblyId == 8 || item.basicAssemblyId == 9) && Array.isArray(values[index]) && values[index].length) {
                            this.returnWhere(values[index][0], 'and', item.basicCode, '>=', item.assemblyType)
                            this.returnWhere(values[index][1], 'and', item.basicCode, '<=', item.assemblyType)
                        } else if (!Array.isArray(values[index]) && values[index]) {
                            this.returnWhere(values[index], 'and', item.basicCode, '%', item.assemblyType)
                        }
                    })
                }
                this.$axios(this.api.metadata.queryElasticsearchTemplatePage, {tableFonctionsList: this.basicDataInfo.tableFonctionsList, ...this.searchForm}, 'post').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    } else {
                        this.$message.error('查询失败');
                    }
                })
            },
            returnWhere(value, method, key, basicTypeMethodCode, assemblyType) {
                let flag = this.searchForm.whereList.filter(item => item.key == key && item.value == value).length
                if (!flag) {
                    this.searchForm.whereList.push({value, method, key, basicTypeMethodCode, assemblyType})
                }
            },
            // 获取字段
            getField(basicDataId) {
                this.treeLoading = true
                this.$axios(this.api.metadata.metadatatableconfigGetById + '?configId=' + this.searchForm.metadataTableConfigId + '&metadataFonctionsModelId=', [], 'post').then(data => {
                    if (data.status) {
                        this.basicDataList = data.data.basicDataIdList
                        this.searchForm.size = parseInt(data.data.defautNombre)
                        this.$nextTick(() => {
                            this.selectMenu(basicDataId || this.basicDataList[0].basicDataId)
                        })
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.treeLoading = false
                })
            },
            // 选择树节点
            selectMenu(val) {
                this.advancedList = []
                this.searchForm.whereList = []
                this.searchForm.sortArchivesDataElasticsearch = []
                this.searchForm.basicDataId = val
                this.basicDataInfo = this.basicDataList.filter(item => item.basicDataId == val)[0]
                this.basicDataInfo.tableFonctionsList = this.basicDataInfo.tableFonctionsList.filter(item => item.disabled == '0')
                // 获取列数据
                this.$axios(this.api.metadata.cacheTableList + '?basicDataId=' + this.searchForm.basicDataId + '&configId=' + this.searchForm.metadataTableConfigId, [], 'post').then(data => {
                    if (data.length) {
                        this.basicDataInfo.tableList = data
                    }
                })
                this.reset()
            },
            // 列表操作按钮
            operateBtn(item, row) {
                if (!row && !this.dataListSelections.length && (item.fonctionsNumber == 'page:collect' || item.fonctionsNumber == 'page:uncollect' || item.fonctionsNumber == 'page:storage' || item.fonctionsNumber == 'page:removal' || item.fonctionsNumber == 'page:hide' || item.fonctionsNumber == 'page:show' || item.fonctionsNumber == 'page:batchSorting' || item.fonctionsNumber == 'page:download' || item.fonctionsNumber == 'page:soldOut' || item.fonctionsNumber == 'page:release' || item.fonctionsNumber == 'page:urgentDeal' || item.fonctionsNumber == 'page:setDesensitizationRules' || item.fonctionsNumber == 'page:qualityInspection' || item.fonctionsNumber == 'page:discussed' || item.fonctionsNumber == 'page:controlledResources' || item.fonctionsNumber == 'page:openResource' || item.fonctionsNumber == 'page:reorganize' || item.fonctionsNumber == 'page:submit' || item.fonctionsNumber == 'page:removeSubject' || item.fonctionsNumber == 'page:changeSubject' || item.fonctionsNumber == 'page:removeLabel' || item.fonctionsNumber == 'page:changeLabel' || item.fonctionsNumber == 'page:removeGrouping' || item.fonctionsNumber == 'page:changeGrouping' || item.fonctionsNumber == 'page:delete' || item.fonctionsNumber == 'list:delete' || item.fonctionsNumber == 'page:pass' || item.fonctionsNumber == 'list:pass' || item.fonctionsNumber == 'page:reject' || item.fonctionsNumber == 'list:reject')) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if (item.fonctionsNumber == 'page:add' || item.fonctionsNumber == 'list:edit' || item.fonctionsNumber == 'list:view') {
                    let type = item.fonctionsNumber.split(":")[1]
                    let id = null
                    if (type != 'add') {
                        id = row.id
                    }
                    this.$refs.resourceAddEditForm.init(type, id, this.searchForm.metadataTableConfigId, this.searchForm.basicDataId)
                } else if (item.fonctionsNumber == 'page:advancedSearch') {
                    this.$refs.advancedSearch.init(this.searchForm.basicDataId, this.advancedList)
                } else if (item.fonctionsNumber == 'page:listSetting') {
                    let list = this.basicDataInfo.tableList.filter(item => item.disabled == '0')
                    if (!list.length) {
                        this.$message.warning('请设置列表项！')
                        return
                    }
                    this.$refs.listSetting.init(this.basicDataInfo.tableList, this.searchForm.metadataTableConfigId, this.searchForm.basicDataId)
                } else if (item.fonctionsNumber == 'page:bulkImport') {
                    this.$refs.importData.init(this.searchForm.metadataTableConfigId, this.searchForm.basicDataId, this.basicDataInfo.tableList, item.metadataFonctionsModelDetailId)
                } else if (item.fonctionsNumber == 'page:bulkExport') {
                    if (!this.dataList.length) {
                        this.$message.warning('暂无可导出的数据！')
                        return
                    }
                    let idList = this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.exportData.init(this.searchForm.metadataTableConfigId, this.searchForm.basicDataId, idList, this.basicDataInfo.basicDataName, this.searchForm)
                } else if (item.fonctionsNumber == 'page:dataMatching') {
                    this.$refs.dataMatching.init(this.searchForm.metadataTableConfigId, this.searchForm.basicDataId, this.basicDataInfo.tableList, this.searchForm)
                } else if (item.fonctionsNumber == 'page:delete' || item.fonctionsNumber == 'list:delete') {
                    this.del(row)
                } else if (item.fonctionsNumber == 'page:discussed' || item.fonctionsNumber == 'page:pass' || item.fonctionsNumber == 'list:pass' || item.fonctionsNumber == 'page:reject' || item.fonctionsNumber == 'list:reject') {
                    this.audit(row, item)
                } else if (item.fonctionsNumber == 'list:download' || item.fonctionsNumber == 'page:download') {
                    this.downloadFile(row)
                } else if (item.fonctionsNumber == 'page:changeGrouping' || item.fonctionsNumber == 'list:changeGrouping') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.changeGrouping.init(this.basicDataInfo.tableList, list)
                } else if (item.fonctionsNumber == 'page:removeGrouping' || item.fonctionsNumber == 'list:removeGrouping') {
                    this.$refs.removeGrouping.init(this.dataListSelections)
                } else if (item.fonctionsNumber == 'page:changeLabel' || item.fonctionsNumber == 'list:changeLabel') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.changeLabel.init(this.basicDataInfo.tableList, list)
                } else if (item.fonctionsNumber == 'page:removeLabel' || item.fonctionsNumber == 'list:removeLabel') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.removeLabel.init(list)
                } else if (item.fonctionsNumber == 'page:changeSubject' || item.fonctionsNumber == 'list:changeSubject') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.changeSubject.init(this.basicDataInfo.tableList, list)
                } else if (item.fonctionsNumber == 'page:removeSubject' || item.fonctionsNumber == 'list:removeSubject') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.removeSubject.init(list)
                } else if (item.fonctionsNumber == 'page:qualityInspection' || item.fonctionsNumber == 'list:qualityInspection') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.qualityInspection.init(this.basicDataInfo.tableList, list)
                } else if (item.fonctionsNumber == 'page:setDesensitizationRules' || item.fonctionsNumber == 'list:setDesensitizationRules') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.setDesensitizationRules.init(list, this.searchForm.basicDataId)
                } else if (item.fonctionsNumber == 'page:urgentDeal' || item.fonctionsNumber == 'list:urgentDeal') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.urgentDeal.init(list)
                } else if (item.fonctionsNumber == 'page:release' || item.fonctionsNumber == 'list:release') {
                    let list = row ? [row] : this.dataListSelections
                    this.$refs.release.init(this.searchForm.basicDataId, list, item.metadataFonctionsModelDetailId)
                } else if (item.fonctionsNumber == 'list:schemeList') {
                    this.$refs.schemeList.init(row)
                } else if (item.fonctionsNumber == 'page:reorganize') {
                    let dataId = this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.reorganize.init(dataId, this.searchForm.metadataTableConfigId, this.searchForm.basicDataId, this.searchForm)
                } else if (item.fonctionsNumber == 'list:auditRecords') {
                    this.$refs.auditRecords.init(row.id)
                } else if (item.fonctionsNumber == 'list:modifyPublish') {
                    this.$refs.modifyPublish.init(row)
                } else if (item.fonctionsNumber == 'page:batchSorting') {
                    let dataId = this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.batchSorting.init(dataId)
                } else if (item.fonctionsNumber == 'page:collect' || item.fonctionsNumber == 'list:collect') {
                    this.collect(row, 1)
                } else if (item.fonctionsNumber == 'page:uncollect' || item.fonctionsNumber == 'list:uncollect') {
                    this.collect(row, 0)
                } else if (item.fonctionsNumber == 'page:storage' || item.fonctionsNumber == 'list:storage') {
                    let ids = row ? [row.id] : this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.storage.init(this.searchForm.basicDataId, ids)
                } else if (item.fonctionsNumber == 'page:removal' || item.fonctionsNumber == 'list:removal') {
                    let ids = row ? [row.id] : this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.removal.init(this.searchForm.basicDataId, ids)
                } else if (item.fonctionsNumber == 'page:backLibrary' || item.fonctionsNumber == 'list:backLibrary') {
                    let ids = row ? [row.id] : this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.backLibrary.init(this.searchForm.basicDataId, ids)
                } else if (item.fonctionsNumber == 'page:backLibrary' || item.fonctionsNumber == 'list:backLibrary') {
                    let ids = row ? [row.id] : this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.backLibrary.init(this.searchForm.basicDataId, ids)
                } else if (item.fonctionsNumber == 'page:handover' || item.fonctionsNumber == 'list:handover') {
                    let ids = row ? [row.id] : this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.handover.init(this.searchForm.basicDataId, ids)
                } else if (item.fonctionsNumber == 'page:acceptance' || item.fonctionsNumber == 'list:acceptance') {
                    let ids = row ? [row.id] : this.dataListSelections.map(item => {
                        return item.id
                    })
                    this.$refs.acceptance.init(this.searchForm.basicDataId, ids)
                } else {
                    this.commonBatch(item, row)
                }
            },
            // 公共批量
            commonBatch(item, row) {
                const h = this.$createElement;
                let tit = `确认${item.detailName}所选资源?`, str = '', confirmButtonText = '确定',
                    api = this.api.metadata.batchUpdateDataByFonctionsModel
                if (item.fonctionsNumber == 'page:soldOut' || item.fonctionsNumber == 'list:soldOut') {
                    api = this.api.metadata.delist
                    str = '确定后资源状态由“已发布”变更为“整编审核通过”，且发布渠道不可见。是否继续？'
                    confirmButtonText = '继续'
                } else if (item.fonctionsNumber == 'page:controlledResources' || item.fonctionsNumber == 'list:controlledResources') {
                    tit = `确认所选资源鉴定为 受控资源?`
                    str = '受控资源支持设置脱敏规则'
                } else if (item.fonctionsNumber == 'page:openResource' || item.fonctionsNumber == 'list:openResource') {
                    tit = `确认所选资源鉴定为 开放资源?`
                } else if (item.fonctionsNumber == 'page:show' || item.fonctionsNumber == 'list:show') {
                    tit = `确认显示所选数据?`
                    str = '确定后发布渠道将显示该数据。是否继续？'
                } else if (item.fonctionsNumber == 'page:hide' || item.fonctionsNumber == 'list:hide') {
                    tit = `确认隐藏所选数据?`
                    str = '确定后发布渠道将隐藏该数据。是否继续？'
                }
                this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                        h('p', {style: 'color: #333333; margin-bottom: 5px'}, tit),
                        h('p', {style: 'color: #999999; font-size: 12px'}, str)
                    ]),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText,
                    cancelButtonText: '取消',
                }).then(() => {
                    this.loading = true
                    let ids = []
                    if (row) {
                        ids = [row.id];
                    } else {
                        ids = this.dataListSelections.map(v => {
                            return v.id
                        })
                    }
                    this.$axios(api, {
                        ids,
                        metadataFonctionsModelDetailId: item.metadataFonctionsModelDetailId,
                        menuId: this.routeInfo.meta.menuId,
                        configId: this.searchForm.metadataTableConfigId,
                    }, 'post').then(data => {
                        if (data.status) {
                            this.$message.success('操作成功')
                            this.refreshList()
                        } else {
                            this.$message.error(data.msg)
                        }
                        this.loading = false
                    })
                })
            },
            // type 1收藏, 0取消收藏
            collect(row, type) {
                let setList = row ? [row] : this.dataListSelections
                let noData = []
                let dtos = setList.map(item => {
                    if (item.isCollect != type) {
                        noData.push(item)
                    }
                    if (type == 1) {
                        return {
                            basicDataId: item.basicDataId,
                            metadataId: item.id,
                        }
                    } else {
                        return item.id
                    }
                })
                let modifyNum = setList.length - noData.length
                if (type == 1) {
                    this.$axios(this.api.metadata.academicMyCollectionSave, dtos, 'post').then(data => {
                        if (data && data.status) {
                            if (row) {
                                this.$message.success('收藏成功')
                            } else {
                                this.$message.success(`已收藏${modifyNum}条资源`)
                            }
                        } else {
                            this.$message.error('收藏失败')
                        }
                        this.refreshList()
                    })
                } else {
                    this.$axios(this.api.metadata.academicMyCollectionUpdateByIds, dtos, 'post').then(data => {
                        if (data && data.status) {
                            if (row) {
                                this.$message.success('取消收藏成功')
                            } else {
                                this.$message.success(`已取消收藏${modifyNum}条资源`)
                            }
                        } else {
                            this.$message.error('取消收藏失败')
                        }
                        this.refreshList()
                    })
                }
            },
            // 审核
            audit(row, item) {
                let ids = []
                if (row) {
                    ids = [row.id];
                } else {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$refs.auditForm.init(ids, item.metadataFonctionsModelDetailId, this.searchForm.metadataTableConfigId)
            },
            // 删除
            del(row) {
                let ids = []
                if (row) {
                    ids = [row.id];
                } else {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.metadata.batchDelete + '?delLocal=' + this.routeInfo.meta.title, ids, 'post').then(data => {
                        if (data.status) {
                            this.$message.success('操作成功')
                            this.$refs.multipleTable.clearSelection()
                            this.refreshList()
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            },
            // 下载
            downloadFile(row) {
                let dataId = []
                if (row) {
                    dataId = [row.id]
                } else {
                    dataId = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$confirm(`确认下载所选资源?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fileBlobDownload(this.api.metadata.downloadFile, {
                        basicDataId: this.searchForm.basicDataId,
                        configId: this.searchForm.metadataTableConfigId,
                        dataId
                    }, '下载文件', 'application/zip')
                })
            },
            // 列表排序
            sortChange(column) {
                let item = this.basicDataInfo.whereList.filter(v => v.basicCode == column.prop)[0]
                this.searchForm.sortArchivesDataElasticsearch = [
                    {
                        assemblyType: item.assemblyType,
                        key: column.prop,
                        sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]
                this.refreshList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 重置
            reset() {
                this.searchForm.keyword = ''
                this.searchForm.whereList = []
                this.advancedList = []
                this.$refs.multipleTable.clearSelection()
                this.form = {}
                this.basicDataInfo.whereList.map(item => {
                    if (item.disabled == '0') {
                        if (item.basicAssemblyId == '6' || item.basicAssemblyId == '7') {
                            this.$set(this.form, item.basicCode, [])
                        } else {
                            this.$set(this.form, item.basicCode, null)
                        }
                    }
                })
                this.$nextTick(() => {
                    this.refreshList(1, 3)
                })
            },
            // 获取高级检索条件
            getSrhCondition(data) {
                if (data) {
                    this.advancedList = data.advancedList
                    this.searchForm.whereList = data.whereList
                    this.refreshList(1, 3)
                }
            },
            hideBtn(item, row) {
                let flag = true
                if(item.fonctionsNumber == 'list:collect' && row.isCollect == '0') {
                    flag = false
                } else if(item.fonctionsNumber == 'list:uncollect' && row.isCollect == '1') {
                    flag = false
                }
                return flag
            },
        },
    }
</script>

<style scoped lang="scss">
    .buttonBox .el-button {
        margin: 0 10px 4px 0 !important;
    }

    .more {
        vertical-align: inherit;
        font-size: 12px !important;
    }

    .btnBox {
        white-space: normal;
    }
</style>
